import React from 'react'
// import ReactSpeedometer from 'react-d3-speedometer'

interface IProps {
  agentValue: any
}

const SpeedMeter: React.FC<IProps> = ({ agentValue }) => {
  const segmentLabels = [
    { text: 'Not Tolerable', color: '#bf616a' },
    { text: 'Below Average', color: '#d08770' },
    { text: 'Average', color: '#ebcb8b' }
  ]

  const segmentLabels2 = [
    { text: 'Good', color: '#a3be8c' },
    { text: 'Outstanding', color: '#b48ead' }
  ]

  const labelStyle: any = {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    top: '70%', // Adjust this value to position the labels correctly
    left: 0,
    right: 0,
    pointerEvents: 'none' // Ensures the overlay doesn't block interactions
  }

  const labelStyle2: any = {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    top: '80%', // Adjust this value to position the labels correctly
    left: 0,
    right: 0,
    pointerEvents: 'none' // Ensures the overlay doesn't block interactions
  }

  const dotStyle = (color: string) => ({
    backgroundColor: color,
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    display: 'inline-block',
    marginRight: '10px'
  })

  return (
    <>
      <div className='card card-xl-stretch mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Customer Feedback Rating</span>
          </h3>
        </div>

        <div className='card-body text-center'>
          {/* <ReactSpeedometer
            value={FeedbackRating}
            segments={5}
            segmentColors={['#bf616a', '#d08770', '#ebcb8b', '#a3be8c', '#b48ead']}
            height={200}
            maxValue={5}
          /> */}
          <div style={labelStyle}>
            {segmentLabels.map(({ text, color }) => (
              <div
                key={text}
                style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}
              >
                <span style={dotStyle(color)}></span>
                <span>{text}</span>
              </div>
            ))}
          </div>
          <div style={labelStyle2}>
            {segmentLabels2.map(({ text, color }) => (
              <div
                key={text}
                style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}
              >
                <span style={dotStyle(color)}></span>
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default SpeedMeter
